// src/shared/json-table/hooks.ts
import { useMemo } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import type { JSONTableProps, TableState } from "./types";
import { buildPostgrestQuery, fetchPostgrestList } from "./postgrest";
import type { ListResponse } from "./postgrest";

export const usePostgrestList = <T,>(
  props: Pick<JSONTableProps<T>,
    "baseUrl" | "resource" | "select" | "staticFilters" | "headers" | "globalSearch" | "queryOptions"
  > & { state: TableState }
) => {
  const select = props.select ?? "*";
  const url = useMemo(
    () =>
      buildPostgrestQuery({
        baseUrl: props.baseUrl,
        resource: props.resource,
        select,
        state: props.state,
        staticFilters: props.staticFilters,
        globalSearchCols: props.globalSearch?.columns,
      }),
    [props.baseUrl, props.resource, select, props.state, props.staticFilters, props.globalSearch?.columns]
  );

  const q = useQuery<ListResponse<T>>({
    queryKey: ["pg", props.baseUrl, props.resource, select, props.state],
    queryFn: () => fetchPostgrestList<T>({ url, headers: props.headers }),
    // Preserve previous page while fetching the next to reduce flicker
    placeholderData: keepPreviousData,
    ...(props.queryOptions as any),
  } as any);

  return { ...q, url };
};
